import * as React from "react";

export default class NotFoundPage extends React.Component<any, any> {
    render() {
        return (
            <div>
                <h2>404</h2>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.tsx